export default "__VITE_ASSET__2d1477da__"